import { PathWithId } from "@constellation-academy/epic-ui";
import { AccountEditPath } from "../account-edit/account-edit.paths";

export class AccountsPath extends PathWithId<typeof AccountsPath> {
	static readonly pathKey = "accounts";
	static readonly idKey = "accountId";
	static readonly childPaths = [AccountEditPath];
}
